var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7018 8.15015C1.47967 7.92803 1.342 7.62145 1.34316 7.28248C1.34316 6.60454 1.89153 6.05618 2.56946 6.05618L13.6571 6.05618C14.335 6.05618 14.8834 6.60454 14.8834 7.28248C14.8834 7.96042 14.335 8.50878 13.6571 8.50878L2.56946 8.50878C2.23049 8.50994 1.92392 8.37227 1.7018 8.15015Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24446 13.7005C7.02233 13.4783 6.88466 13.1718 6.88582 12.8328L6.88698 1.73476C6.88698 1.05682 7.43534 0.508453 8.11328 0.508453C8.79238 0.50961 9.34074 1.05798 9.33958 1.73476L9.33843 12.8328C9.33843 13.5107 8.79006 14.0591 8.11213 14.0591C7.77316 14.0603 7.46542 13.9214 7.24446 13.7005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a56c9df8fc32eb25800a6c578fbfa59b.svg";
export { ForwardRef as ReactComponent };